export default class ClientConfig {
  public clientId: string = ''
  public name: string = ''
  public tenantId: string = ''
  public connectionString: string = ''
  public notificationHubPath: string = ''
  public isDebugHub: boolean = false
  public supportsFirebaseV1 = true
  public migratedToFirebaseV1 = true
  public registrationCount = 0
}
